import { requestBuilder } from '../../http/RequestBuilder';

// From synctera-v0
export enum PatchPaymentScheduleStatus {
    CANCELLED = 'CANCELLED',
}

interface UpdatePaymentScheduleResponse {
    status: string;
}

interface UpdatePaymentScheduleBody {
    status: PatchPaymentScheduleStatus;
}

interface UpdatePaymentScheduleURLParams {
    paymentScheduleId: string;
}

const useCancelPaymentSchedule = requestBuilder.mutation<
    UpdatePaymentScheduleResponse,
    UpdatePaymentScheduleBody,
    UpdatePaymentScheduleURLParams
>({
    endpoint: ({ paymentScheduleId }) =>
        `/api/payment-schedules/${paymentScheduleId}`,
    method: 'PATCH',
});

export default useCancelPaymentSchedule;
